module.exports = __webpack_public_path__ + "img/inspiration_06.46a2cab.jpg";